module.exports = __webpack_public_path__ + "media/flags/lc-d95265b2.svg";